type OneOfKey<T> = T extends unknown ? Exclude<keyof T, '!type'> & string : never;

export function getOneOfType<T extends object>(value: T | undefined, defaultValue?: OneOfKey<T>): OneOfKey<T> | undefined {
  if (!value) return defaultValue;

  if ('!type' in value && value['!type']) {
    return value['!type'] as OneOfKey<T>;
  }

  const keys = Object.keys(value) as Array<OneOfKey<T>>;
  return keys[0] ?? defaultValue;
}

export type ExcludeByType<T, K> = T extends { '!type'?: K } ? never : T;
